import AxiosRequest from "../AxiosClient";

export const getHomeContent = () => {
    return AxiosRequest({
        url: `/api/site/home-content`,
        method: "GET",
    })
};

export const getPartnerContent = () => {
    return AxiosRequest({
        url: `/api/site/partner-content`,
        method: "GET",
    })
};

export const getVehicleContent = () => {
    return AxiosRequest({
        url: `/api/site/vehicle-content`,
        method: "GET",
    })
};

export const getVehiclePartnerContent = () => {
    return AxiosRequest({
        url: `/api/site/vehicle-partner-content`,
        method: "GET",
    })
};

export const getDriverContent = () => {
    return AxiosRequest({
        url: `/api/site/driver-content`,
        method: "GET",
    })
};

export const getDriverPartnerContent = () => {
    return AxiosRequest({
        url: `/api/site/driver-partner-content`,
        method: "GET",
    })
}
